<template>
  <div>
    <a-tabs defaultActiveKey="1">
      <a-tab-pane tab="PARAMETROS" key="1">
        <a-form-model :model="filterParams" v-bind="fiOptions" ref="filterForm">
          <a-row :gutter="[16,16]">
            <a-col v-bind="colSpan">
              <a-form-model-item label="Compañía" prop="company" has-feedback
                                 :rules="[{ required: true, message: 'Valor requerido' }]">
                <form-model-dropdown style="width: 100%"
                                     v-model="filterParams.company"
                                     endpoint="company">
                </form-model-dropdown>
              </a-form-model-item>
            </a-col>
            <a-col v-bind="colSpan">
              <a-form-model-item label="Año" prop="year" has-feedback
                                 :rules="[{ required: true, message: 'Valor requerido' }]">
                <a-input-number style="width: 100%;" v-model="filterParams.year"></a-input-number>
              </a-form-model-item>
            </a-col>
            <a-col v-bind="colSpan">
              <a-form-model-item :label="$t('Tipo de pago')" prop="company" has-feedback
                                 :rules="[{ required: false, message: 'Valor requerido' }]">
                <form-model-dropdown style="width: 100%"
                                     v-model="filterParams.tpay"
                                     endpoint="hierarchy_lookup"
                                     :params="tpay">
                </form-model-dropdown>
              </a-form-model-item>
            </a-col>
            <a-col v-bind="colSpan">
              <a-form-model-item :wrapper-col="{ span: 16 }">
                <a-button type="primary" @click="filtrar">Filtrar</a-button>
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-form-model>
      </a-tab-pane>
    </a-tabs>
    <a-tabs v-model="tabActivo">
      <a-tab-pane tab="RESUMEN" :key="1">
        <a-spin :spinning="resumeChart.chartLoading">
          <a-card style="min-height: 400px">
            <canvas id="resumen" width="400" height="400"></canvas>
          </a-card>
        </a-spin>
      </a-tab-pane>
      <a-tab-pane tab="DETALLE X ITEM" :key="2">
        <div style="display:flex; justify-content:flex-end; width:100%; padding:0;">
          <a-button :loading="buttonExcelLoading" style="background-color: rgb(29, 111, 66); color: white"
                    icon="file-excel" @click="exportarExcel('DetalleXItem')">
            Excel
          </a-button>
        </div>
        <br>
        <g-datatable :endpoint="masterSetup.endpoint"
                     :columns="masterSetup.tableSetup.columns"
                     :tableConfig="masterSetup.tableSetup.tableConfig"
                     :requestData="masterRequestData"
                     :customSlots="masterSetup.tableSetup.customSlots"
                     :actions="masterSetup.actions"
                     @action="masterAction"
                     ref="masterComp">
          <div slot="nominaRender" slot-scope="{record, text}" style="text-align: right;">
                            <span style="color: green;"
                                  v-if="record.coc_natu === 'DEV'">{{format(parseInt(text))}}</span>
            <span style="color: red;" v-if="record.coc_natu === 'DED'">{{format(parseInt(text))}}</span>
            <span style="color: blue;"
                  v-if="record.coc_natu === 'NXP'">{{format(parseInt(text))}}</span>
          </div>
        </g-datatable>
      </a-tab-pane>
      <a-tab-pane tab="PERSONAS X ITEM" :key="3">
        <div style="display:flex; justify-content:flex-end; width:100%; padding:0;">
          <a-button :loading="buttonExcelLoading" style="background-color: rgb(29, 111, 66); color: white"
                    icon="file-excel" @click="exportarExcel('PersonasXItem')">
            Excel
          </a-button>
        </div>
        <br>
        <g-datatable :endpoint="detalleSetup.endpoint"
                     :columns="detalleSetup.tableSetup.columns"
                     :tableConfig="detalleSetup.tableSetup.tableConfig"
                     :requestData="detalleRequestData"
                     :customSlots="detalleSetup.tableSetup.customSlots"
                     ref="detalleComp">
          <div slot="nominaRender" slot-scope="{record, text}" style="text-align: right;">
                            <span style="color: green;"
                                  v-if="record.coc_natu === 'DEV'">{{format(parseInt(text))}}</span>
            <span style="color: red;" v-if="record.coc_natu === 'DED'">{{format(parseInt(text))}}</span>
            <span style="color: blue;"
                  v-if="record.coc_natu === 'NXP'">{{format(parseInt(text))}}</span>
          </div>
        </g-datatable>
      </a-tab-pane>
    </a-tabs>
  </div>

</template>
<script>
  import NumberUtils from '@/util/NumberUtils'
  import JsUtils from '@/util/JsUtils'
  import HttpUtil from '@/util/HttpUtil'
  import Chart from 'chart.js'
  import Mensajes from 'CustomModules/GlobalBPOCore/Util/Mensajes'

  export default {
    data () {
      return {
        tpay: {
          h_lookup_type: 'TIPO PAGO',
          use_code: true
        },
        id_coc: null,
        buttonExcelLoading: false,
        tabActivo: 1,
        colSpan: {
          xs: 24,
          md: 8
        },
        fiOptions: {
          'label-col': {span: 8},
          'wrapper-col': {span: 16},
          'has-feedback': true
        },
        filterParams: {
          year: moment().year()
        },
        loading: {
          resumen: false
        },
        resumeChart: {
          chartLoading: false,
          resumenData: {},
          chart: {}
        },
        masterRequestData: {},
        masterSetup: {
          endpoint: 'payroll_management',
          tableSetup: {
            columns: [
              {title: 'Item', dataIndex: 'coc_name', sorter: true, fixed: 'left'},
              {
                title: 'Enero',
                dataIndex: 'enero',
                sorter: true,
                scopedSlots: {
                  filterDropdown: 'filterDropdown',
                  filterIcon: 'filterIcon',
                  customRender: 'nominaRender'
                }
              },
              {
                title: 'Febrero',
                dataIndex: 'febrero',
                sorter: true,
                scopedSlots: {
                  filterDropdown: 'filterDropdown',
                  filterIcon: 'filterIcon',
                  customRender: 'nominaRender'
                }
              },
              {
                title: 'Marzo',
                dataIndex: 'marzo',
                sorter: true,
                scopedSlots: {
                  filterDropdown: 'filterDropdown',
                  filterIcon: 'filterIcon',
                  customRender: 'nominaRender'
                }
              },
              {
                title: 'Abril',
                dataIndex: 'abril',
                sorter: true,
                scopedSlots: {
                  filterDropdown: 'filterDropdown',
                  filterIcon: 'filterIcon',
                  customRender: 'nominaRender'
                }
              },
              {
                title: 'Mayo',
                dataIndex: 'mayo',
                sorter: true,
                scopedSlots: {
                  filterDropdown: 'filterDropdown',
                  filterIcon: 'filterIcon',
                  customRender: 'nominaRender'
                }
              },
              {
                title: 'Junio',
                dataIndex: 'junio',
                sorter: true,
                scopedSlots: {
                  filterDropdown: 'filterDropdown',
                  filterIcon: 'filterIcon',
                  customRender: 'nominaRender'
                }
              },
              {
                title: 'Julio',
                dataIndex: 'julio',
                sorter: true,
                scopedSlots: {
                  filterDropdown: 'filterDropdown',
                  filterIcon: 'filterIcon',
                  customRender: 'nominaRender'
                }
              },
              {
                title: 'Agosto',
                dataIndex: 'agosto',
                sorter: true,
                scopedSlots: {
                  filterDropdown: 'filterDropdown',
                  filterIcon: 'filterIcon',
                  customRender: 'nominaRender'
                }
              },
              {
                title: 'Septiembre',
                dataIndex: 'septiembre',
                sorter: true,
                scopedSlots: {
                  filterDropdown: 'filterDropdown',
                  filterIcon: 'filterIcon',
                  customRender: 'nominaRender'
                }
              },
              {
                title: 'Octubre',
                dataIndex: 'octubre',
                sorter: true,
                scopedSlots: {
                  filterDropdown: 'filterDropdown',
                  filterIcon: 'filterIcon',
                  customRender: 'nominaRender'
                }
              },
              {
                title: 'Noviembre',
                dataIndex: 'noviembre',
                sorter: true,
                scopedSlots: {
                  filterDropdown: 'filterDropdown',
                  filterIcon: 'filterIcon',
                  customRender: 'nominaRender'
                }
              },
              {
                title: 'Diciembre',
                dataIndex: 'diciembre',
                sorter: true,
                scopedSlots: {
                  filterDropdown: 'filterDropdown',
                  filterIcon: 'filterIcon',
                  customRender: 'nominaRender'
                }
              },
              {
                title: 'Total',
                dataIndex: 'total',
                sorter: true,
                scopedSlots: {
                  filterDropdown: 'filterDropdown',
                  filterIcon: 'filterIcon',
                  customRender: 'nominaRender'
                }
              },
              {title: 'ID Concepto', dataIndex: 'id_coc', sorter: true}
            ],
            tableConfig: {
              rowKey: 'id_coc',
              pagination: {
                pageSize: 100,
                current: 1,
                showSizeChanger: true,
                pageSizeOptions: ['5', '10', '20', '30', '40', '100', '200', '500', '1000', '10000']
              }
            },
            customSlots: ['nominaRender']
          },
          actions: {
            title: 'Acciones',
            scopedSlots: {customRender: 'hooverableAction'},
            width: 100,
            fixed: 'right',
            actions: [
              {
                name: 'detalles',
                text: 'Detalles',
                permisos: [],
                props: {size: 'small', type: 'link', icon: 'info-circle'}
              }
            ]
          }
        },
        detalleRequestData: {},
        detalleSetup: {
          endpoint: 'payroll_management_detail',
          tableSetup: {
            columns: [
              {title: 'Empleado', dataIndex: 'nombre', sorter: true, fixed: 'left'},
              {title: 'Identificación', dataIndex: 'id_emp', sorter: true},
              {
                title: 'Enero',
                dataIndex: 'enero',
                sorter: true,
                scopedSlots: {
                  filterDropdown: 'filterDropdown',
                  filterIcon: 'filterIcon',
                  customRender: 'nominaRender'
                }
              },
              {
                title: 'Febrero',
                dataIndex: 'febrero',
                sorter: true,
                scopedSlots: {
                  filterDropdown: 'filterDropdown',
                  filterIcon: 'filterIcon',
                  customRender: 'nominaRender'
                }
              },
              {
                title: 'Marzo',
                dataIndex: 'marzo',
                sorter: true,
                scopedSlots: {
                  filterDropdown: 'filterDropdown',
                  filterIcon: 'filterIcon',
                  customRender: 'nominaRender'
                }
              },
              {
                title: 'Abril',
                dataIndex: 'abril',
                sorter: true,
                scopedSlots: {
                  filterDropdown: 'filterDropdown',
                  filterIcon: 'filterIcon',
                  customRender: 'nominaRender'
                }
              },
              {
                title: 'Mayo',
                dataIndex: 'mayo',
                sorter: true,
                scopedSlots: {
                  filterDropdown: 'filterDropdown',
                  filterIcon: 'filterIcon',
                  customRender: 'nominaRender'
                }
              },
              {
                title: 'Junio',
                dataIndex: 'junio',
                sorter: true,
                scopedSlots: {
                  filterDropdown: 'filterDropdown',
                  filterIcon: 'filterIcon',
                  customRender: 'nominaRender'
                }
              },
              {
                title: 'Julio',
                dataIndex: 'julio',
                sorter: true,
                scopedSlots: {
                  filterDropdown: 'filterDropdown',
                  filterIcon: 'filterIcon',
                  customRender: 'nominaRender'
                }
              },
              {
                title: 'Agosto',
                dataIndex: 'agosto',
                sorter: true,
                scopedSlots: {
                  filterDropdown: 'filterDropdown',
                  filterIcon: 'filterIcon',
                  customRender: 'nominaRender'
                }
              },
              {
                title: 'Septiembre',
                dataIndex: 'septiembre',
                sorter: true,
                scopedSlots: {
                  filterDropdown: 'filterDropdown',
                  filterIcon: 'filterIcon',
                  customRender: 'nominaRender'
                }
              },
              {
                title: 'Octubre',
                dataIndex: 'octubre',
                sorter: true,
                scopedSlots: {
                  filterDropdown: 'filterDropdown',
                  filterIcon: 'filterIcon',
                  customRender: 'nominaRender'
                }
              },
              {
                title: 'Noviembre',
                dataIndex: 'noviembre',
                sorter: true,
                scopedSlots: {
                  filterDropdown: 'filterDropdown',
                  filterIcon: 'filterIcon',
                  customRender: 'nominaRender'
                }
              },
              {
                title: 'Diciembre',
                dataIndex: 'diciembre',
                sorter: true,
                scopedSlots: {
                  filterDropdown: 'filterDropdown',
                  filterIcon: 'filterIcon',
                  customRender: 'nominaRender'
                }
              },
              {
                title: 'Total',
                dataIndex: 'total',
                sorter: true,
                scopedSlots: {
                  filterDropdown: 'filterDropdown',
                  filterIcon: 'filterIcon',
                  customRender: 'nominaRender'
                }
              }
            ],
            tableConfig: {
              rowKey: 'id_emp',
              pagination: {
                pageSize: 100,
                current: 1,
                showSizeChanger: true,
                pageSizeOptions: ['5', '10', '20', '30', '40', '100', '200', '500', '1000', '10000']
              }
            },
            customSlots: ['nominaRender']
          }
        }
      }
    },
    created () {
      this.httpClient = new HttpUtil()
    },
    methods: {
      exportarExcel (tabla) {
        let ruta = ''
        let nombre_archivo = ''
        let params = {}
        if (tabla === 'DetalleXItem') {
          ruta = 'payroll_management/detallexitem/downloadExcel'
          nombre_archivo = 'DetalleXItem.xlsx'
          params = {
            company: this.filterParams.company,
            year: this.filterParams.year,
            tpay: this.filterParams.tpay
          }
        } else {
          ruta = 'payroll_management/personasxitem/downloadExcel/' + this.filterParams.company + '/' + this.filterParams.year + '/' + this.id_coc
          nombre_archivo = 'PersonaXItem.xlsx'
        }

        if (!this.$isEmpty(this.filterParams.company) && !this.$isEmpty(this.filterParams.year)) {
          this.buttonExcelLoading = true
          this.httpClient.getInstance().get(ruta, {
            responseType: 'arraybuffer',
            params
          })
            .then(response => {
              let fileURL = new Blob([response.data], {type: response.headers['content-type']})
              fileURL = window.URL.createObjectURL(fileURL)
              let fileLink = document.getElementById('file_link_elm')
              if (fileLink === null) {
                fileLink = document.createElement('a')
                fileLink.setAttribute('id', 'file_link_elm')
                document.body.appendChild(fileLink)
              }

              fileLink.setAttribute('href', fileURL)
              fileLink.setAttribute('download', nombre_archivo)
              fileLink.click()
              this.buttonExcelLoading = false
              Mensajes.success('Correcto', 'Se descargó su archivo con éxito.')
            })
            .catch(() => {
              this.buttonExcelLoading = false
              Mensajes.error('Error', 'No fue posible descargar el archivo.')
            })
            .then(() => {
              this.buttonExcelLoading = false
            })
        } else {
          Mensajes.info('Información', 'Debes agregar un parámetro de búsqueda para descargar el archivo')
        }
      },

      filtrar () {
        this.$refs.filterForm.validate(valid => {
          if (valid) {
            this.loading.resumen = true
            this.resumeChart.chartLoading = true
            this.masterRequestData = {...this.filterParams}
            this.httpClient.getInstance().get('payroll_management/resumen',
              {
                params: this.filterParams
              })
              .then(response => {
                if (JsUtils.isEmpty(this.resumeChart.chart)) {
                  this.initResumeChart(response.data)
                } else {
                  this.updateResumeChart(response.data)
                }
              })
              .catch(() => {})
              .then(() => {
                this.resumeChart.chartLoading = false
              })
          }
        })
      },
      initResumeChart (barChartData) {
        this.resumeChart.resumenData = barChartData

        this.resumeChart.chart = new Chart('resumen', {
          type: 'line',
          data: this.resumeChart.resumenData,
          options: {
            maintainAspectRatio: false,
            responsive: true,
            title: {
              display: true,
              text: 'Resumen de Calificación'
            },
            scales: {
              xAxes: [{
                gridLines: {
                  display: true
                }
              }],
              yAxes: [{
                gridLines: {
                  display: true
                }
              }]
            },
            tooltips: {
              enabled: true,
              callbacks: {
                label: (tooltipItem, data) => {
                  let label = data.datasets[tooltipItem.datasetIndex].label || ''

                  if (label) {
                    label += ': '
                  }
                  label += this.format(tooltipItem.yLabel)
                  return label
                }
              }
            }
          }
        })
      },
      updateResumeChart (barChartData) {
        this.resumeChart.resumenData.datasets.splice(0, this.resumeChart.resumenData.datasets.length)
        this.resumeChart.resumenData.labels.splice(0, this.resumeChart.resumenData.labels.length)
        barChartData.labels.map(label => {
          this.resumeChart.resumenData.labels.push(label)
        })
        barChartData.datasets.map(dataset => {
          this.resumeChart.resumenData.datasets.push(dataset)
        })
        this.resumeChart.chart.update()
      },
      format (value) {
        return NumberUtils.formatMoney(value, 0)
      },
      masterAction (action) {
        switch (action.action) {
          case 'detalles':
            this.id_coc = action.record.id_coc
            this.detalleRequestData = {
              ...this.filterParams,
              'id_coc': action.record.id_coc
            }
            this.tabActivo = 3
            break
        }
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Reportes/PayrollManagement/PayrollManagement.vue